import React from 'react';
import { Col, Row } from 'reactstrap';
import { CheckboxPillGroupFormHook } from '../../../../../../components/CheckboxPillGroupFormHook';
import { CreateJobDto } from '../../../../../../services/applicant_tracking/JobService/CreateJobDto';
import { AVAILABLE_WORKING_MODELS } from '../../../../../../utils/applicant_tracking/jobDetails';
import { Control } from 'react-hook-form';
import classNames from 'classnames';

interface PropTypes {
  formControl: Control<CreateJobDto>;
  formResetField: (controllerName: string) => void;
}

export function WorkplaceInput(props: PropTypes) {
  const required = true;

  return (
    <Row className='mt-4'>
      <Col xs={3} className={'align-self-end mb-1'}>
        <div className={'mb-2 d-flex align-items-end'}>
          <label className={classNames('me-auto fw-semibold fs-5')}>
            Workplace
            <span className='ps-1 text-danger'>*</span>
          </label>
        </div>
        <CheckboxPillGroupFormHook<CreateJobDto>
          formHookContext={{
            controllerName: 'locationType',
            formControl: props.formControl,
            required: required,
          }}
          resetField={props.formResetField}
          childrenProps={AVAILABLE_WORKING_MODELS}
        />
      </Col>
    </Row>
  );
}
